import { Request } from "../stores/Requests20";
import { handleServiceResponse } from "./ServerRequestsInternal";
import { url } from "../utils/UrlUtil";
import type { CheckoutCustomer } from "../model/CheckoutData";
export type GetCustomerParams = {
	country: string;
	customerId: string;
	cardholderId: string;
};
export function getCustomer({ country, customerId, cardholderId }: GetCustomerParams): Promise<CheckoutCustomer> {
	const requestPath = url`/ordercapture/checkout/customer/${country}/${customerId}/${cardholderId}`;
	return handleServiceResponse(Request.get(requestPath).execute()).then((response) => response.data);
}
